module.exports = require('./helpers/bundle-url').getBundleURL('bqp0F') + "logo-dark.eefe0b7f.svg";